import { Injectable, inject } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { ClientByShortcodeQueryService, ClientFragment } from '@app-graphql/api-schema'

@Injectable({ providedIn: 'root' })
export class ShortcodeService {
    private readonly clientByShortcodeQueryService = inject(ClientByShortcodeQueryService)


    public async getClientByShortcode(shortcode: string): Promise<ClientFragment | null> {
        const result = await firstValueFrom(
            this.clientByShortcodeQueryService.fetch({ variables: { shortcode } }),
        )

        return result.data?.clients.data[0] ?? null
    }
}
